import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@chefami-monorepo/data-access';

/**
 * Backs the `/logout` route (external links): logs out, which ends in a
 * full-page redirect, so the navigation itself is cancelled.
 */
export const logoutGuard: CanActivateFn = () => {
  inject(AuthService).logout();
  return false;
};
